module.exports = __webpack_public_path__ + "static/img/img02@2x.1cd8c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/img02@2x.png
// module id = 70IY
// module chunks = 174